import type { Dictionary, GetterClass, MessagesState } from '../../../models'
import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

export class LocaleGetter implements GetterClass {
  static execute(this: void, state: MessagesState): string {
    const messages = CONTAINER.get<Dictionary<Dictionary>>(TYPES.Messages)
    if (state.locale in messages) {
      return state.locale
    }
    const trimmedLocale = state.locale.slice(0, 2)
    if (trimmedLocale in messages) {
      return trimmedLocale
    }
    return state.fallbackLocale
  }
}
